$(document).ready(function(){

	// -- Hamburger --
	var $body = $('body');
	var $menu = $('.header__menu');
	var $toggle = $('.hamburger');
	var $menuLinks = $menu.find('a');

	function setMenuState(isOpen, options){
		options = options || {};
		var focusOnOpen = options.focusOnOpen !== false;
		$body.toggleClass('menu--open', isOpen);
		$toggle.toggleClass('is-active', isOpen);
		$toggle.attr('aria-expanded', isOpen ? 'true' : 'false');
		$menu.attr('aria-hidden', isOpen ? 'false' : 'true');

		var label = isOpen ? $toggle.data('close') : $toggle.data('open');
		$toggle.find('.hamburger__label').text(label);

		if (isOpen) {
			$menuLinks.removeAttr('tabindex');
			if (focusOnOpen) {
				var $first = $menuLinks.filter(':visible').first();
				if ($first.length) {
					$first.focus();
				}
			}
		} else {
			$menuLinks.attr('tabindex', '-1');
			if (options.focusToggle) {
				$toggle.focus();
			}
		}
	}

	// Initialize menu as closed
	setMenuState(false, { focusToggle: false });

	$toggle.on('click', function(e){
		var willOpen = !$body.hasClass('menu--open');
		if (willOpen) {
			var isKeyboard = $body.attr('data-whatinput') === 'keyboard' || e.detail === 0;
			setMenuState(true, { focusOnOpen: isKeyboard });
		} else {
			setMenuState(false);
		}
	});

	// -- Close mobile menu when click
	$('.header__menu .mainMenu li a:not(.dropdown-toggle)').on('click', function(){
		setMenuState(false, { focusToggle: true });
	});

	// -- Close dropdown when click outside --
	$(document).on('mouseup', function(e) {
	  var container = $('.header');
	  if (!container.is(e.target) && container.has(e.target).length === 0) {
			setMenuState(false, { focusToggle: false });
	  }
	});

	// // -- Dropdown --
	// $(document).on('click', '.dropdown-toggle', function(e){
	// 	e.preventDefault();		
	// 	if (!$(this).parent('.dropdown').hasClass('open')) {
	// 		$('.dropdown').removeClass('open');
	// 		$(this).parent('.dropdown').toggleClass('open');
	// 	} else {
	// 		$('.dropdown').removeClass('open');
	// 	}
	// });

	// // -- Close dropdown when click outside --
	// $(document).on('mouseup', function(e) {
	//   var container = $('.dropdown');
	//   if (!container.is(e.target) && container.has(e.target).length === 0) {
	// 		$('.dropdown').removeClass('open');
	//   }
	// });

	// // -- Close dropdown on mouseleave --
	// var closeDropdownMenu; // global
	// $('.main__nav').on('mouseleave', '.dropdown-menu', function(){
	// 	closeDropdownMenu = setTimeout(function(){
	// 		$('.dropdown').removeClass('open');
	// 	},3000);
	// });

	// // -- Clear timeout to prevent close dropdown on mouseenter --
	// $('.main__nav').on('mouseenter', '.dropdown-menu', function(){
	// 	clearTimeout(closeDropdownMenu);
	// });

	$(document).on('keydown', function(e){
		if ((e.key === 'Escape' || e.key === 'Esc') && $body.hasClass('menu--open')) {
			setMenuState(false, { focusToggle: true });
		}
	});

});



$(document).on('scroll resize orientationchange', function(){
	// -- Header fixed --
	var scrollTop = $(this).scrollTop();
	var header = $('.header').outerHeight();
	if (scrollTop > header) {
		$('body').addClass('header--fixed');
	} else {
		$('body').removeClass('header--fixed');
	}

});
